// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OM2i","select":"styles_select__2ZEz2"};